import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

/**
 * Demonstration environment banner shown at the top of every /care-portal/demo/* route.
 * Consistent, unmistakable labeling for prospects and CCCHAPS staff.
 */
export default function DemoBanner({ title = "BALM — CCCHAPS Care Portal Demonstration Environment", subtitle }) {
  return (
    <div data-testid="care-portal-demo-banner" className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-xs sm:text-sm text-amber-900">
          <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={2} aria-hidden="true" />
          <span>
            <strong>{title}</strong>
            {subtitle ? <span className="text-amber-800/90"> — {subtitle}</span> : null}
          </span>
        </div>
        <Link
          to="/care-portal/demo"
          data-testid="care-portal-demo-banner-back"
          className="text-xs text-amber-900 hover:text-amber-950 font-medium"
        >
          Demo Hub →
        </Link>
      </div>
    </div>
  );
}
